import { useQuery } from '@tanstack/react-query';
import { useOrganizationStore } from '@/core/stores/organization.store';
import { projectFilesService } from '../api/project-files.service';
import { PROJECT_FILE_KEYS } from './queryKeys';
import type { GetFilesParams } from '../types';

export function useProjectFiles(projectId: string, params?: GetFilesParams) {
  const orgId = useOrganizationStore((s) => s.activeOrganizationId);

  return useQuery({
    queryKey: PROJECT_FILE_KEYS.list(orgId ?? '', projectId, params),
    queryFn: async ({ signal }) => {
      const response = await projectFilesService.getFiles(projectId, params, signal);
      return response.data;
    },
    staleTime: 30_000,
    enabled: !!orgId && !!projectId,
  });
}
